export const getThresholdRangeError = (
  ranges: Array<{ label: string; lower?: string; upper?: string }>,
) => {
  for (const { label, lower = '', upper = '' } of ranges) {
    if (lower !== '' && upper !== '' && Number(lower) > Number(upper)) {
      return `${label}の下限閾値は上限閾値以下にしてください。`;
    }
  }
  return '';
};
